import { CustomSignInForm } from "./CustomSignInForm";
import { CustomSignUpForm } from "./CustomSignUpForm";

interface LoginFormProps {
  view: 'sign_in' | 'sign_up';
  onViewChange: (view: 'sign_in' | 'sign_up') => void;
  onRecoveryClick: () => void;
}

export const LoginForm = ({ view, onViewChange, onRecoveryClick }: LoginFormProps) => {
  const handleSwitchToSignUp = () => {
    onViewChange('sign_up');
  };

  const handleSwitchToSignIn = () => {
    onViewChange('sign_in');
  };

  return (
    <div className="w-full max-w-md">
      {view === 'sign_in' ? (
        <CustomSignInForm 
          onSwitchToSignUp={handleSwitchToSignUp}
          onRecoveryClick={onRecoveryClick}
        />
      ) : (
        <CustomSignUpForm 
          onSwitchToSignIn={handleSwitchToSignIn}
        />
      )}
    </div>
  );
};